import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import api from '../../../services/api';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import { Checkbox, FormControlLabel, Button } from '@mui/material';
import { CheckBoxOutlineBlank, CheckBox } from '@mui/icons-material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PageContainer from '../../../common/components/PageContainer';
import useAlerta from '../../../common/components/useAlerta';
import AppSnackbar from '../../../common/components/AppSnackbar';
import PermissoesPicker from '../../../common/components/PermissoesPicker';
import usePermissoes from '../../../common/hooks/usePermissoes';

function CadastroFuncionario() {
  const { register, handleSubmit, reset } = useForm();
  const { alerta, mostrarAlerta, fecharAlerta } = useAlerta();
  const { isTI: temPermissaoTI } = usePermissoes();
  const [imageData, setImageData] = useState(null);
  const [permissoes, setPermissoes] = useState([]);
  const [setores, setSetores] = useState([]);
  const [exibirPermissoes, setExibirPermissoes] = useState(false);
  const [exibirSetores, setExibirSetores] = useState(false);
  const [permissoesSelecionadas, setPermissoesSelecionadas] = useState([]);
  const [setorSelecionado, setSetorSelecionado] = useState("");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      convertToBase64(file);
    }
  };

  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setImageData(reader.result);
    };
    reader.onerror = (error) => {
      console.error('Erro ao converter a imagem para Base64:', error);
    };
  };

  const handleCheckboxChange = (permissaoId) => {
    setPermissoesSelecionadas((prevState) =>
      prevState.includes(permissaoId)
        ? prevState.filter((id) => id !== permissaoId)
        : [...prevState, permissaoId]
    );
  };

  const handleToggleGrupo = (idsGrupo, marcar) => {
    setPermissoesSelecionadas((prevState) =>
      marcar
        ? Array.from(new Set([...prevState, ...idsGrupo]))
        : prevState.filter((id) => !idsGrupo.includes(id))
    );
  };

  const handleCheckboxChangeSetor = (setorId) => {
    setSetorSelecionado(setorId);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await api.get(`/permissao`);
        setPermissoes(response.data);
        const responseSetor = await api.get(`/setor`);
        setSetores(responseSetor.data);
      } catch (error) {
        console.error('Erro ao buscar informações', error);
      }
    }
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    if (!imageData) {
      console.error('Nenhuma imagem foi selecionada.');
      return;
    }

    const formData = {
      ...data,
      foto: imageData,
      permissoes: permissoesSelecionadas,
      setor: setorSelecionado,
    };

    try {
      await api.post('/funcionario', formData);
      mostrarAlerta('Funcionário cadastrado com sucesso!', 'success');
      setTimeout(() => {
        window.location.href = '/funcionario';
      }, 1500);
    } catch (error) {
      mostrarAlerta('Erro ao cadastrar funcionário!', 'error');
      reset();
      setImageData(null);
    }
    setTimeout(fecharAlerta, 3000);
  };

  return (
    <PageContainer sx={{ maxWidth: 900 }}>
      <Paper component="form" onSubmit={handleSubmit(onSubmit)} sx={{ p: { xs: 2, sm: 4 } }}>
        <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 600, mb: 3 }}>
          Cadastro de Funcionário
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <Avatar src={imageData || undefined} sx={{ width: 96, height: 96, bgcolor: 'primary.light' }}>
            {!imageData && <PersonOutlineIcon fontSize="large" />}
          </Avatar>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={8}>
            <TextField {...register("nome")} label="Nome completo" placeholder="Digite o nome..." required fullWidth />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField {...register("nRegistro")} label="Nº Registro" placeholder="Digite o número de registro..." fullWidth />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField {...register("dataAdmissao")} label="Data de Admissão" type="date" InputLabelProps={{ shrink: true }} fullWidth />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField {...register("dataDemissao")} label="Data de Demissão" type="date" InputLabelProps={{ shrink: true }} fullWidth />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField {...register("telefone")} label="Telefone" type="tel" placeholder="Digite o telefone..." fullWidth />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField {...register("cpf")} label="CPF" placeholder="Digite o CPF..." fullWidth />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField {...register("cargo")} label="Cargo" placeholder="Digite o cargo..." fullWidth />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField {...register("data_aniversario")} label="Data de nascimento" type="date" InputLabelProps={{ shrink: true }} fullWidth />
          </Grid>

          <Grid item xs={6} sm={4}>
            <TextField {...register("tamCamisa")} label="Tamanho da Camisa" placeholder="Digite o tamanho..." fullWidth />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField {...register("tamCalca")} label="Tamanho da Calça" placeholder="Digite o tamanho..." fullWidth />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField {...register("nCalcado")} label="Nº Calçado" type="number" fullWidth />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField {...register("salario")} label="Salário" fullWidth />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField {...register("email")} label="Email" type="email" placeholder="Digite o email..." required fullWidth />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField {...register("senha")} label="Senha" type="password" placeholder="Digite a senha..." required fullWidth />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button variant="outlined" component="label" fullWidth sx={{ height: '100%' }}>
              Selecionar foto
              <input
                {...register("foto")}
                type="file"
                accept="image/*"
                hidden
                onChange={handleFileChange}
                required
              />
            </Button>
          </Grid>
        </Grid>

        {temPermissaoTI && (
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setExibirPermissoes(!exibirPermissoes)}
            sx={{ mt: 3 }}
          >
            {exibirPermissoes ? "Ocultar Permissões" : "Selecionar Permissões"}
          </Button>
        )}

        {exibirPermissoes && (
          <Box sx={{ mt: 1 }}>
            <PermissoesPicker
              permissoesDisponiveis={permissoes}
              selecionadas={permissoesSelecionadas}
              onToggle={handleCheckboxChange}
              onToggleGrupo={handleToggleGrupo}
            />
          </Box>
        )}

        <Box>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setExibirSetores(!exibirSetores)}
            sx={{ mt: 2 }}
          >
            {exibirSetores ? "Ocultar Setores" : "Selecionar Setor"}
          </Button>
        </Box>

        {exibirSetores && (
          <Box sx={{ mt: 1 }}>
            {setores.map((setor) => (
              <FormControlLabel
                key={setor.id}
                control={
                  <Checkbox
                    icon={<CheckBoxOutlineBlank fontSize="small" />}
                    checkedIcon={<CheckBox fontSize="small" />}
                    checked={setorSelecionado === setor.id}
                    onChange={() => handleCheckboxChangeSetor(setor.id)}
                    color="secondary"
                  />
                }
                label={setor.nome}
              />
            ))}
          </Box>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Button type="submit" variant="contained" color="secondary" size="large" sx={{ px: 6 }}>
            Cadastrar
          </Button>
        </Box>
      </Paper>

      <AppSnackbar alerta={alerta} onClose={fecharAlerta} />
    </PageContainer>
  );
}

export default CadastroFuncionario;
